export default __webpack_public_path__ + "static/media/bodyPaint-2.9b655ef3.jpg";